<template>
  <div>
    <div class="weui-cells__title" v-show="!notitle || title" v-if="notitle || title">{{ title }}</div>
    <div class="weui-cells" :class="[type ? 'weui-cells_' + type : null]">
      <slot />
    </div>
    <div class="weui-cells__tips" v-if="tips">{{ tips }}</div>
  </div>
</template>

<script>
export default {
    name: 'Group',
    props: {
        notitle: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: null,
        },
        tips: {
            type: String,
            default: null,
        },
    },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/weui/group/Index.vue